<template>
    <div>
        <div class="history sec-details">
                            <div class="d-flex align-items-center justify-content-between">
                                <h1>Security Details</h1>
                                <!-- <div class="action">
                                    <a href="#"><i class="fa fa-cog"></i></a>
                                    <a href="#" class="mx-3"><i class="fa fa-expand"></i></a>
                                    <a href="#"><i class="fa fa-times"></i></a>
                                </div> -->
                            </div>
                            <b-tabs  v-if="cusipId">
                            <!-- MSRB Trades -->
                            <b-tab title="Security Overview" active>
                                <div class="col-md-12">
                                    <div class="row  values">
                                        <div
                                            class="col-auto"
                                            v-for="(value, key) in defaultDetails"
                                            :key="key"
                                        >
                                            <span>{{ convertToWord(key) }}</span>
                                            <span>{{ value ? value : "N/A" }}</span>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Security Details">
                                <div class="col-md-12">
                                    <div class="row values" style="max-height: 200px; overflow-y: scroll;">
                                        <div
                                            class="col-auto"
                                            v-for="(value, key) in referenceData"
                                            :key="key"
                                        >
                                            <span >{{ convertToWord(key) }}</span>

                                            <span 
                                                v-if="convertToWord(key) === 'ISSUE AMOUNT' || 
                                                      convertToWord(key) === 'ISSUE PRICE' || 
                                                      convertToWord(key) === 'AMOUNT OUTSTANDING'"> {{ value | currency }}</span>
                                            <span v-else>{{ value ? value : "N/A" }}</span>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <!-- My Bids -->
                            <b-tab title="Call Schedules">
                                <div class="table-responsive p-0">
                                <table class="table table-striped table-hover w-100">
                                    <thead>
                                    <tr>
                                        <th scope="col">Call Date</th>
                                        <th scope="col" class="text-right">Call Price</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                     <tr v-if="callSchedule.length == 0">
                                        <td><p class="nodata">No data available</p></td>
                                    </tr>
                                    <tr v-for="data in callSchedule" :key="data.id">
                                        <th scope="row">{{ data.callDate }}</th>
                                        <td class="text-right">{{ data.callPrice | currency }}</td>
                                    </tr>
                                   
                                    </tbody>
                                </table>
                                </div>
                            </b-tab>
                            <!-- My Trades -->
                            <b-tab title="Material Events">
                                <div class="table-responsive p-0">
                                <table class="table table-striped table-hover w-100">
                                    <thead>
                                    <tr>
                                        <th scope="col">Event Date</th>
                                        <th scope="col">Event Code</th>
                                        <!-- <th scope="col">Event Type</th> -->
                                        <!-- <th scope="col">Event Status</th> -->
                                        <!-- <th scope="col">Correction Date</th> -->
                                        <th scope="col">Message</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                     <tr v-if="materialEvents.length == 0">
                                        <td><p class="nodata">No data available</p></td>
                                    </tr>
                                    <tr v-for="data in materialEvents" class="cursor-pointer" :key="data.id" @click="toggleMaterialEventModal(data)">
                                        <td>{{ data.eventDate }}</td>
                                        <td>{{ data.eventCode }}</td>
                                        <!-- <td>{{ data.eventType }}</td> -->
                                        <!-- <td>{{ data.eventStatus }}</td> -->
                                        <!-- <td>{{ data.correctionDate }}</td> -->
                                        <td>{{ data.messageText }}</td>
                                    </tr>
                                   
                                  
                                    </tbody>
                                </table>
                                </div>
                            </b-tab>
                            <b-tab title="Sink Schedules">
                                <div class="table-responsive p-0">
                                <table class="table table-striped table-hover w-100">
                                    <thead>
                                    <tr>
                                        <th scope="col" class="text-left">Sink Date</th>
                                        <th scope="col" >Sink Amount</th>
                                        <th scope="col" class="text-right">Sink Price</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-if="sinkSchedules.length == 0">
                                            <td><p class="nodata">No data available</p></td>
                                        </tr>
                                        <tr v-for="data in sinkSchedules" :key="data.id">
                                            <td class="text-left">{{ data.sinkDate }}</td>
                                            <td >{{ data.sinkAmount }}</td>
                                            <td class="text-right">{{ data.sinkPrice | currency }}</td>
                                        </tr>
                                    
                                    </tbody>
                                </table>
                                </div>
                            </b-tab>
                            <b-tab title="Partial Redemption Data">
                                <div class="table-responsive p-0">
                                <table class="table table-striped table-hover w-100">
                                    <thead>
                                    <tr>
                                        <th scope="col">Date</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col" class="text-right">Price</th>
                                        <th scope="col">Type</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="partialRedumptionData.length == 0">
                                        <td><p class="nodata">No data available</p></td>
                                    </tr>
                                    <tr v-for="data in partialRedumptionData" :key="data.id">
                                        <td>{{ data.partialRedemptionDate }}</td>
                                        <td>{{ data.partialRedemptionAmount }}</td>
                                        <td>{{ data.partialRedemptionPrice | currency }}</td>
                                        <td>{{ data.partialRedemptionType }}</td>
                                    </tr>
                                   
                                    </tbody>
                                </table>
                                </div>
                            </b-tab>
                        </b-tabs>
                        </div>
             <MaterialEvent  v-if="showMaterialModal" :eventData="selectedEvent" @close="toggleMaterialEventModal"/>           
    </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import stateConstants from "@/stateConstants";
import MaterialEvent from '@/components/client/MaterialDataModal.vue'



export default {
    name: 'SecurityDetails',
    props :["cusipId"],
    components: {
        MaterialEvent
    },
    watch: { 
    cusipId: function() { // watch it
          this.getCusipDetails();
        }
    },
    data() {
        return {
            cusipObj: {},
            referenceData: {},
            defaultDetails: {},
            callSchedule: [],
            materialEvents: [],
            sinkDetails: {},
            sinkSchedules: [],
            partialRedumptionData: [],
            loading: false,
            stateConstants: stateConstants,
            showMaterialModal : false,
            selectedEvent : null

        };
    },
    methods: {
        toggleMaterialEventModal(data){
            this.selectedEvent = data;
            this.showMaterialModal = !this.showMaterialModal;
        },
        convertToWord(text) {
            const result = text.replace(/([A-Z])/g, " $1");
            let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
            finalResult = finalResult.toUpperCase();
            return finalResult;
        },
        getStateName(id) {
            return id ? this.stateConstants.find((x) => x.id === id).short : "N/A";
        },
        getCusipDetails() {
        this.loading = true;
        if(!this.cusipId){
            this.loading = false;
            return;
        }
        const auth = {
            headers: { "org-token": authService.getOrgToken() },
        };
        this.$http
            .get(config.baseUrlBidSide + "/cusip/" + this.cusipId, auth)
            .then(
            (result) => {
                if (result.data) {
                result.data.coupon = (result.data.coupon * 100).toFixed(3);
                // result.data.stateId = result.data.stateId ? result.data.stateId : '0';
                result.data.product =
                    result.data.offeringTypeId == 1 ? "MUNICIPAL" : "CORPORATE";
                result.data.offeringType =
                    result.data.offeringTypeId == 1 ? "MUNIS" : "CORPORATES";
                result.data.state = this.getStateName(result.data.stateId);
                delete result.data.id;
                delete result.data.isSecurityMasterExist;
                delete result.data.offeringTypeId;
                delete result.data.stateId;
                delete result.data.status;
                delete result.data.callDate;

                if(result.data.defaultDetails){
                    for (const property in result.data.defaultDetails) {
                    //console.log(`${property}: ${object[property]}`);
                    delete result.data[property]
                    }
                }
                this.referenceData = result.data.referenceData;

                 //Show fields in the following order CUSIP, Description, Coupon, Maturity Date, Call date, S & P rating, Min Den, Insurance, Proceeds, State in defaultDetails.
                 this.defaultDetails = result.data.defaultDetails;
                 console.log("defaultDetails before rearranging", this.defaultDetails);
                  const orderedKeys = ['cusip', 'issuer', 'coupon', 'maturityDate', 'nextCallDate', 's&pRating', 'minDenom', 'insurance', 'proceeds', 'st'];
                 const rearrangedDetails = {};

                orderedKeys.forEach(key => {
                if (Object.prototype.hasOwnProperty.call(this.defaultDetails, key)) {
                    rearrangedDetails[key] = this.defaultDetails[key];
                }
                });


                this.defaultDetails = rearrangedDetails;

                this.defaultDetails.coupon = (this.defaultDetails.coupon * 100).toFixed(3);

                if (result.data.referenceData) {
                    this.callSchedule = result.data.referenceData.callSchedules;
                    this.materialEvents = result.data.referenceData.materialEvents;
                    this.sinkDetails = result.data.sinkDetails;
                    this.sinkSchedules = result.data.referenceData.sinkSchedules;
                    this.partialRedumptionData =
                    result.data.referenceData.partialRedemptions;

                    delete this.referenceData.callSchedules;
                    delete this.referenceData.materialEvents;
                    delete this.referenceData.sinkDetails;
                    delete this.referenceData.sinkSchedules;
                    delete this.referenceData.partialRedemptions;
                    delete this.referenceData.instrumentId;
                }
                delete result.data.referenceData;
                delete result.data.defaultDetails;
                
                }
                this.loading = false;
                this.cusipObj = result.data;
            },
            () => {
                this.loading = false;
            }
            );
        }
     
    },
    mounted() {
    //    this.getCusipDetails();
    }
};
</script>
